<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.order_status") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-btn
        v-if="items.length < 5"
        @click="$refs.table_ref.toggleDialog()"
        class="primary"
      >
        <span>{{ $t("button.create") }}</span>
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      :pathName="$route.name"
      class="table-row"
      dialogWidth="500"
      @get_items="getItems"
      @on_dialog_close="OnDialogClose"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          {{ item.text }}
        </td>
        <td class="text-sm-center">
          <v-chip :color="item.color"></v-chip>
        </td>

        <td class="text-sm-center">
          <v-icon
            @click="handleEdit(item, index)"
            :title="$t('icon.edit')"
            small
            >mdi-pencil</v-icon
          >

          <v-icon
            :title="$t('icon.delete')"
            @click="handleDelete(item, index)"
            small
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dilaog -->
      <template #wrraping_dialog>
        <v-card-title class="dialog_header">{{
          $t("headings.create")
        }}</v-card-title>
        <v-card-text>
          <formWrapper :validator="$v.form">
            <v-form @submit.prevent="handleSubmit" class="mt-5">
              <v-row>
                <v-col v-if="isEdit" cols="12" md="6" class="mx-auto">
                  <locale-select v-model="locale" @change="changeLocale" />
                </v-col>
                <v-col cols="12">
                  <form-group name="text">
                    <template slot-scope="{ attrs, listeners }">
                      <v-text-field
                        outlined
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="form.text"
                      ></v-text-field>
                    </template>
                  </form-group>
                </v-col>
                <v-col cols="12">
                  <v-color-picker
                    hide-mode-switch
                    mode="hexa"
                    v-model="form.color"
                  ></v-color-picker>
                </v-col>
              </v-row>
              <v-btn
                type="submit"
                :loading="loading"
                :disabled="$v.form.$invalid"
                class="primary"
              >
                <span>{{ $t("button.save") }}</span>
                <v-icon small right>mdi-send</v-icon>
              </v-btn>
            </v-form>
          </formWrapper>
        </v-card-text>
      </template>
      <!-- dilaog -->
    </wrapping-table>
  </main>
</template>
<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { ShowData } from "@/helpers/apiMethods";
export default {
  name: "OrderStatus",
  props: {
    resName: {
      type: String,
      default: "status",
    },
    pathName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      headers: ["text", "color", "actions"],
      loading: false,
      form: {
        text: "",
        color: {},
      },
      items: [],
      isEdit: false,
      statusIndex: "",
      statusId: "",
      locale: this.locale,
    };
  },

  methods: {
    changeLocale(locale) {
      this.locale = locale;
      this.handleShow(locale);
    },
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleEdit({ id }, index) {
      this.$refs.table_ref.toggleDialog();
      this.statusIndex = index;
      this.statusId = id;
      this.isEdit = true;
      this.handleShow();
    },
    handleSubmit() {
      this.loading = true;
      const { text, color } = this.form;
      const reqData = { text, color: color.hex, locale: this.locale };

      if (!this.isEdit) {
        // in case create

        this.$refs.table_ref
          .handleOnCreate(this.$route.name, reqData, this.resName)
          .finally(() => (this.loading = false));
      } else {
        // in case edit
        reqData._method = "put";
        reqData.locale = this.locale;
        reqData.color = this.form.color;
        this.$refs.table_ref
          .handleOnEdit(
            this.$route.name,
            reqData,
            this.statusId,
            this.resName,
            this.statusIndex
          )
          .finally(() => (this.loading = false));
      }
    },
    handleShow(locale = this.locale) {
      ShowData({
        reqName: this.pathName,
        param: this.statusId,
        locale,
      }).then((res) => {
        const { status } = res.data;
        this.form = status;
      });
    },
    getItems(items) {
      this.items = items;
    },
    OnDialogClose() {
      this.backToDefult();
    },
    backToDefult() {
      this.$v.$reset();
      this.form = { text: "", color: {} };
      this.isEdit = false;
    },
  },
  validations: {
    form: {
      text: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(30),
      },
      color: {
        required,
      },
    },
  },
};
</script>
